/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrototypeFirmwareUserModel
 */
export interface PrototypeFirmwareUserModel {
    /**
     * 
     * @type {string}
     * @memberof PrototypeFirmwareUserModel
     */
    firmware_id: string;
    /**
     * 
     * @type {string}
     * @memberof PrototypeFirmwareUserModel
     */
    auth_id: string;
}

/**
 * Check if a given object implements the PrototypeFirmwareUserModel interface.
 */
export function instanceOfPrototypeFirmwareUserModel(value: object): value is PrototypeFirmwareUserModel {
    if (!('firmware_id' in value) || value['firmware_id'] === undefined) return false;
    if (!('auth_id' in value) || value['auth_id'] === undefined) return false;
    return true;
}

export function PrototypeFirmwareUserModelFromJSON(json: any): PrototypeFirmwareUserModel {
    return PrototypeFirmwareUserModelFromJSONTyped(json, false);
}

export function PrototypeFirmwareUserModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrototypeFirmwareUserModel {
    if (json == null) {
        return json;
    }
    return {
        
        'firmware_id': json['firmware_id'],
        'auth_id': json['auth_id'],
    };
}

export function PrototypeFirmwareUserModelToJSON(json: any): PrototypeFirmwareUserModel {
    return PrototypeFirmwareUserModelToJSONTyped(json, false);
}

export function PrototypeFirmwareUserModelToJSONTyped(value?: PrototypeFirmwareUserModel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firmware_id': value['firmware_id'],
        'auth_id': value['auth_id'],
    };
}

